import axios from "axios"
import React, { useState, useEffect, useMemo, Fragment, useRef } from "react"

import { FormControl, InputLabel, Input, FormHelperText, Alert } from "@mui/material"
import WebService from "@util/webService"
import { encodeParams, getAction } from "@util/helper"
// redux
import { useSelector, useDispatch } from "react-redux"
// MUI Table
import CssBaseline from "@mui/material/CssBaseline"
import MUITable from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableCell from "@mui/material/TableCell"
import TableHead from "@mui/material/TableHead"
import TableRow from "@mui/material/TableRow"
import TableFooter from "@mui/material/TableFooter"
// react-table
import { useTable, useExpanded } from "react-table"
import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown"
import IconButton from "@mui/material/IconButton"
import CloseIcon from "@mui/icons-material/Close"
import SearchIcon from "@mui/icons-material/Search"
import AddCircleIcon from "@mui/icons-material/AddCircle"
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField, withStyles, InputBase } from "@mui/material"
import { styled, alpha } from "@mui/material/styles"
import "@scss/App.scss"
import Button from "@mui/material/Button"
import FlatButton from "@components/FlatButton"
import useSnackbar from "@hooks/useSnackbar"
import MyTableHead from "@components/MyTableHead"
import useIndicator from "@hooks/useIndicator"
import Indicator from "@components/Indicator"
import MyDialog from "@components/MyDialog"
import useForm from "@hooks/useForm"
import Box from "@mui/material/Box"
import MenuItem from "@mui/material/MenuItem"
import Select from "@mui/material/Select"
// pagination
import { useTheme } from "@mui/material/styles"
import FirstPageIcon from "@mui/icons-material/FirstPage"
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft"
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight"
import LastPageIcon from "@mui/icons-material/LastPage"
import ControlPointIcon from "@mui/icons-material/ControlPoint"
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline"
import Paper from "@mui/material/Paper"
import moment from "moment"
import { Avatar, Grid, Container } from "@mui/material/"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import { isNewExpression } from "@babel/types"
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete"
import { searchSchool } from "@util/helper"

const Boxs = styled(Box)`
	padding-bottom: 40px !important;
`

const FormHelperTexts = styled(FormHelperText)`
	width: 100%;
	padding-left: 16px;
	font-weight: 700 !important;
	color: #d32f2f !important;
`

const RLTN_CODE = "S003"
const TeacherRegiPart = () => {
	console.log("ManagerRegiPart rendering...")
	const g_sel_code = "SA07"
	const g_stat_code = "SA12"
	const g_week_code = "SB07"

	const inputRef = useRef()
	const defUrl = "/regi"
	const dateFormat = "YYYY-MM-DD HH:mm:ss"
	const [detailScreen, set_detailScreen] = useState(false)
	const [isNew, set_isNew] = useState(false)
	const [schoolList, set_schoolList] = useState([])
	const [studentList, set_studentList] = useState([])
	const [teacherList, set_teacherList] = useState([])
	const [smstList, set_smstList] = useState([])
	const [lessonList, set_lessonList] = useState([])
	const [lectureList, set_lectureList] = useState([])
	const [selCodeList, set_selCodeList] = useState([])
	const [statCodeList, set_statCodeList] = useState([])
	const [weekCodeList, set_weekCodeList] = useState([])

	const fields = [
		{
			field: "id",
			placeholder: "아이디",
			type: "text",
			value: -1,
			visible: false,
			canSrch: false,
			selList: [],
		},
		{
			field: "schoolName",
			placeholder: "학교명",
			type: "text",
			value: "",
			visible: !detailScreen,
			canSrch: false,
			disabled: true,
			selList: [],
		},
		{
			field: "lectureName",
			placeholder: "강좌명",
			type: "text",
			value: "",
			visible: !detailScreen,
			canSrch: false,
			disabled: true,
			selList: [],
		},
		{
			field: "studentId",
			placeholder: "학생ID",
			type: "select",
			value: "",
			visible: detailScreen,
			canSrch: false,
			disabled: !isNew,
			selList: studentList,
		},
		{
			field: "studentName",
			placeholder: "학생명",
			type: "text",
			value: "",
			visible: !detailScreen,
			canSrch: false,
			selList: [],
		},
		{
			field: "guardianNum",
			placeholder: "보호자 전화번호",
			type: "text",
			value: "",
			visible: !detailScreen,
			canSrch: false,
			disabled: true,
			selList: [],
		},
		{
			field: "lectureId",
			placeholder: "강좌명",
			type: "select",
			value: "",
			visible: detailScreen,
			canSrch: false,
			disabled: !isNew,
			selList: lectureList,
		},

		{
			field: "userId",
			placeholder: "유저ID",
			type: "select",
			value: "",
			visible: false,
			canSrch: false,
			selList: [],
		},
		{
			field: "statCode",
			placeholder: "상태",
			type: "select",
			value: "",
			visible: detailScreen,
			canSrch: false,
			selList: statCodeList,
		},
		{
			field: "statCodeName",
			placeholder: "상태",
			type: "select",
			value: "",
			visible: !detailScreen,
			canSrch: false,
			selList: [],
		},
		{
			field: "regCode",
			placeholder: "등록코드",
			type: "text",
			value: "",
			visible: false,
			canSrch: false,
			selList: [],
		},
		{
			field: "regTime",
			placeholder: "등록일시",
			type: "text",
			value: "",
			visible: false,
			canSrch: false,
			selList: [],
		},
		{
			field: "uptTime",
			placeholder: "수정일시",
			type: "text",
			value: "",
			visible: false,
			canSrch: false,
			selList: [],
		},
	]
	// const [fields, set_fields] = useState([...defFields])

	const gdnFields = [
		{ field: "name", placeholder: "성명" },
		{ field: "loginId", placeholder: "ID" },
		{ field: "phone", placeholder: "전화번호" },
		{ field: "phoneCertYn", placeholder: "인증여부" },
	]

	const regiLectureFields = [
		{ field: "title", placeholder: "강좌제목", table: "lecture" },
		{
			field: "statCode",
			placeholder: "신청상태",
			table: "regi",
			fn: (code) => findCode("SA12", code),
		},
		{
			field: "regCode",
			placeholder: "등록상태",
			table: "regi",
			fn: (code) => findCode("SB12", code),
		},
		{
			field: "statCode",
			placeholder: "강좌상태",
			table: "lecture",
			fn: (code) => findCode("SA09", code),
		},
	]

	const visibleColumns = fields.filter((col) => col.visible)
	const defRecord = {}
	fields.forEach((d) => {
		defRecord[d.field] = d.value
	})
	defRecord.schoolList = []
	const defTerms = {}
	fields
		.filter((col) => col.canSrch)
		.map((d) => d.field)
		.forEach((d) => (defTerms[d] = ""))
	const [record, set_record] = useState(defRecord)
	const [dataList, set_dataList] = useState([])
	const [schoolGroup, set_schoolGroup] = useState([])

	const [skipPageReset, setSkipPageReset] = React.useState(false)
	const [openSnackbar, renderSnackbar] = useSnackbar()
	const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
	const dgHandler = useState(false)
	const [selIdx, set_selIdx] = useState(-1)
	const [pageNum, set_pageNum] = useState(0)
	const [pageSize, set_pageSize] = useState(10)
	const [totalCount, set_totalCount] = useState(0)
	const [pageInfo, set_pageInfo] = useState({ pageNum: 0, pageSize: -1 })
	const [terms, _set_terms] = useState(defTerms)
	const [fontSize, set_fontSize] = useState(12)
	const [selStudentList, set_selStudentList] = useState([])
	const termsRef = useRef(terms)
	const [schoolRowSpan, set_schoolRowSpan] = useState({})

	// redux
	const codeGroups = useSelector((state) => state.codeGroupReducer)
	const codes = useSelector((state) => state.codeReducer)
	const schools = useSelector((state) => state.schoolReducer)

	const set_terms = (data) => {
		termsRef.current = data
		_set_terms(data)
	}

	// const schoolRowSpan = useMemo((schoolId) => {
	//   let rowspan = 1
	//   Object.keys(dataList).forEach(key => {
	//     if(dataList[key].length > 0) {
	//       if(+dataList[key][0].schoolId === +schoolId) {
	//         rowspan = rowspan + 1

	//         rowspan = rowspan + dataList[key].length
	//       }
	//     }
	//   })
	//   return rowspan
	// }, [dataList])

	const onLoad = async () => {
		openIndicator()
		let url = defUrl
		const newTerms = {}
		Object.keys(termsRef.current).forEach((key) => {
			if (termsRef.current[key] !== "") {
				newTerms[key] = termsRef.current[key]
			}
		})

		let tempList
		let resp = await WebService.get(url, {
			pageNum: pageInfo.pageNum,
			pageSize: pageInfo.pageSize,
			terms: JSON.stringify(newTerms),
		})

		if (resp.repCode === "ack") {
			const repMessage = JSON.parse(resp.repMessage)
			const originList = JSON.parse(repMessage.records)
			const regis = originList.reduce((acc, cur, idx, arr) => {
				const regi = cur.regi

				const student = cur.student
				regi.studentName = student.name
				regi.guardianNum = student.guardianNum

				const school = cur.school
				regi.schoolId = school.id
				regi.schoolName = school.name

				acc.push(regi)
				return acc
			}, [])

			const records = regis
			const totalCount = repMessage.totalCount
			set_totalCount(totalCount)

			tempList = records
		}

		tempList.forEach((temp) => {
			const found = schools.find((d) => d.id === temp.schoolId)
			if (found) {
				temp.schoolName = found.name
			}
		})

		// 학기
		url = "/smst"
		resp = await WebService.get(url, {})

		if (resp.repCode === "ack") {
			const repMessage = JSON.parse(resp.repMessage)
			const records = JSON.parse(repMessage.records)
			records.forEach((r) => {
				const school = schools.find((s) => s.id === +r.schoolId)
				if (school) {
					r.name = `${school.name}/${r.year}/${r.gisu}`
				} else {
					console.log("smst not found")
				}
			})
			records.unshift({ id: -1, name: "학교 기수 선택" })
			set_smstList(records)

			tempList.forEach((temp) => {
				const found = records.find((d) => d.id === temp.smstId)
				if (found) {
					temp.smstName = found.name
				}
			})
		}

		// 레슨
		url = "/lesson"
		resp = await WebService.get(url, {})

		if (resp.repCode === "ack") {
			const repMessage = JSON.parse(resp.repMessage)
			const records = JSON.parse(repMessage.records)
			records.forEach((r) => {
				r.name = r.title
			})
			records.unshift({ id: -1, name: "레슨 선택" })
			set_lessonList(records)

			tempList.forEach((temp) => {
				const found = records.find((d) => d.id === temp.lessonId)
				if (found) {
					temp.lessonName = found.name
				}
			})
		}

		// 강좌
		url = "/lecture"
		resp = await WebService.get(url, {})

		if (resp.repCode === "ack") {
			const repMessage = JSON.parse(resp.repMessage)
			const records = JSON.parse(repMessage.records)
			records.forEach((r) => {
				r.name = r.title
			})
			records.unshift({ id: -1, name: "강좌 선택" })
			set_lectureList(records)

			tempList.forEach((temp) => {
				const found = records.find((d) => d.id === temp.lectureId)
				if (found) {
					temp.lectureName = found.name
				}
			})
		}

		// 코드
		let records
		records = codes.filter((c) => c.codeGroupId === g_sel_code)
		records.forEach((r) => {
			r.id = r.code
		})
		records.unshift({ id: -1, name: "선발방식 선택" })
		set_selCodeList(records)
		tempList.forEach((temp) => {
			const found = records.find((d) => d.id === temp.selCode)
			if (found) {
				temp.selCodeName = found.name
			}
		})

		records = codes.filter((c) => c.codeGroupId === g_stat_code)
		records.forEach((r) => {
			r.id = r.code
		})
		records.unshift({ id: -1, name: "상태 선택" })
		set_statCodeList(records)
		tempList.forEach((temp) => {
			const found = records.find((d) => d.id === temp.statCode)
			if (found) {
				temp.statCodeName = found.name
			}
		})

		records = codes.filter((c) => c.codeGroupId === g_week_code)
		records.forEach((r) => {
			r.id = r.code
		})
		records.unshift({ id: -1, name: "요일 선택" })
		set_weekCodeList(records)
		tempList.forEach((temp) => {
			const found = records.find((d) => d.id === temp.weekCode)
			if (found) {
				temp.weekCodeName = found.name
			}
		})

		// teacher list
		url = "/user/school"
		resp = await WebService.get(url, { rltnCode: RLTN_CODE })
		if (resp.repCode === "ack") {
			const repMessage = JSON.parse(resp.repMessage)
			const records = JSON.parse(repMessage.records)
			records.unshift({ id: -1, name: "강사 선택" })
			set_teacherList(records)

			tempList.forEach((st) => {
				const found = records.find((d) => d.id === st.userId)
				if (found) {
					st.userName = found.name
				}
			})
		}

		// student list
		url = "/student"
		resp = await WebService.get(url, { rltnCode: RLTN_CODE })
		if (resp.repCode === "ack") {
			const repMessage = JSON.parse(resp.repMessage)
			const records = JSON.parse(repMessage.records)
			records.unshift({ id: -1, name: "학생 선택" })
			set_studentList(records)
			// tempList.forEach(st => {
			//   const found = records.find(d => d.id === st.userId)
			//   if(found) {
			//     st.userName = found.name
			//   }
			// })
		}

		// group by lectureId
		const lectureGroup = tempList.reduce((acc, cur) => {
			if (acc[cur.lectureId]) {
				acc[cur.lectureId].push(cur)
			} else {
				cur.rowSpan = 2
				acc[cur.lectureId] = [cur]
			}
			return acc
		}, {})

		const schoolGroup = tempList.reduce((acc, cur) => {
			if (acc[cur.schoolId]) {
				acc[cur.schoolId].push(cur)
			} else {
				acc[cur.schoolId] = [cur]
			}
			return acc
		}, {})

		set_schoolGroup(schoolGroup)

		const newSchoolRowSpan = {}

		Object.keys(schoolGroup).forEach((schoolId) => {
			let rowspan = 1
			Object.keys(lectureGroup).forEach((lectureId) => {
				if (lectureGroup[lectureId].length > 0) {
					if (+lectureGroup[lectureId][0].schoolId === +schoolId) {
						rowspan = rowspan + 1
						rowspan = rowspan + lectureGroup[lectureId].length
					}
				}
			})
			newSchoolRowSpan[schoolId] = rowspan
		})

		set_schoolRowSpan(newSchoolRowSpan)

		set_dataList(lectureGroup)
		closeIndicator()
	}

	const onDetail = async (id) => {
		set_detailScreen(true)
		dgHandler[1](true)
	}

	const onDelete = async (id) => {
		const url = defUrl
		const resp = await WebService.delete(url, { id: id })
		if (resp.repCode === "ack") {
			onLoad()
			openSnackbar("삭제되었습니다.")
		} else {
			openSnackbar(resp.repMessage)
		}
	}

	const onCreate = () => {
		const now = moment().format(dateFormat)
		const newRecord = {
			...defRecord,
			regTime: now,
			uptTime: now,
			schoolRltnList: [],
		}
		newRecord.guardian = {}
		newRecord.userId = -1
		newRecord.statCode = "S001"
		newRecord.regCode = "S001"
		newRecord.regiAndLectureList = []
		set_record(newRecord)
		set_detailScreen(true)
		set_isNew(true)
		dgHandler[1](true)
	}

	const onSearch = () => {
		onLoad()
	}

	const onClear = () => {
		const obj = {}
		Object.keys(terms).forEach((k) => {
			obj[k] = ""
		})
		set_terms(obj)
	}

	const handleChangePage = (event, newPage) => {
		set_pageInfo({ ...pageInfo, pageNum: newPage })
	}

	const handleChangeRowsPerPage = (event) => {
		const pageSize = parseInt(event.target.value, 10)
		set_pageInfo({ pageNum: 0, pageSize: pageSize })
	}

	const TablePaginationActions = (props) => {
		const theme = useTheme()
		const { count, page, rowsPerPage, onPageChange } = props

		const handleFirstPageButtonClick = (event) => {
			onPageChange(event, 0)
		}

		const handleBackButtonClick = (event) => {
			onPageChange(event, page - 1)
		}

		const handleNextButtonClick = (event) => {
			onPageChange(event, page + 1)
		}

		const handleLastPageButtonClick = (event) => {
			onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1))
		}

		return (
			<Box sx={{ flexShrink: 0, ml: 2.5 }}>
				<IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label='first page'>
					{theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
				</IconButton>
				<IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label='previous page'>
					{theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
				</IconButton>
				<IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label='next page'>
					{theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
				</IconButton>
				<IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label='last page'>
					{theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
				</IconButton>
			</Box>
		)
	}

	const findCode = (codeGroupId, code) => {
		const found = codes.filter((d) => d.codeGroupId === codeGroupId).find((d) => d.code === code)
		return found
	}

	const loadSelStudentList = async (lectureId) => {
		const url = `${defUrl}/sel/student`
		const action = getAction(url, { lectureId: lectureId })
		const resp = await WebService.get(action)
		set_selStudentList([])
		if (resp.repCode === "ack") {
			const repMessage = JSON.parse(resp.repMessage)
			const records = JSON.parse(repMessage.records)
			set_selStudentList(records)
			openSnackbar("선밞/마감하였습니다.")
		}
	}

	const genAttdnc = async (lectureId) => {
		const url = `/attdnc/${lectureId}`
		const action = getAction(url, {})
		const resp = await WebService.post(action)
		if (resp.repCode === "ack") {
			openSnackbar("출석부를 생성하였습니다.")
		} else {
			openSnackbar(resp.repMessage)
		}
	}

	const Item = styled(Paper)(({ theme }) => ({
		backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
		...theme.typography.body2,
		padding: theme.spacing(1),
		textAlign: "center",
		color: theme.palette.text.secondary,
	}))

	const DgContent = () => {
		const xs = 12 / visibleColumns.length <= 3 ? 3 : 12 / visibleColumns.length
		const onSubmit = async () => {

			const url = `${defUrl}`
			const data = activeRow
			const resp = await WebService.post(url, data)
			if (resp.repCode === "ack") {
				onLoad()
				handleChange()
				openSnackbar("저장되었습니다.")
			} else {
				openSnackbar("에러 발생")
			}
		}

		const validate = () => {}
		const [activeRow, errors, formLoading, handleChange, handleSubmit] = useForm({
			initialValues: { ...record },
			onSubmit: onSubmit,
			validate: validate,
		})
		const [emailError, setEmailError] = useState("")
		const [passwordState, setPasswordState] = useState("")
		const [passwordError, setPasswordError] = useState("")
		const [nameError, setNameError] = useState("")
		const [registerError, setRegisterError] = useState("")

		// const Boxs = styled(Box)`
		//   padding-bottom: 40px !important;
		// `;

		const label = { inputProps: { "aria-label": "Checkbox demo" } }

		return (
			<Container component='main' maxWidth='lg'>
				<CssBaseline />
				<Box
					sx={{
						marginTop: 8,
						display: "flex",
						flexDirection: "column",
					}}>
					<Typography component='h1' variant='h5'>
						기본정보
					</Typography>
					<Boxs component='form' noValidate sx={{ mt: 3 }}>
						<FormControl component='fieldset' variant='standard' fullWidth>
							<Grid container spacing={2}>
								{fields.map((col, index) => {
									if (col.visible) {
										if (col.type === "select") {
											return (
												<Grid item xs={xs} key={col.field}>
													<FormControl fullWidth>
														<InputLabel>{col.placeholder}</InputLabel>
														<Select required value={activeRow[col.field]} label={activeRow[col.placeholder]} name={col.field} onChange={handleChange} size='small' disabled={col.disabled}>
															{col.selList.map((l) => {
																return <MenuItem value={l.id}>{l.name}</MenuItem>
															})}
														</Select>
													</FormControl>
												</Grid>
											)
										} else {
											return (
												<Grid item xs={xs} key={col.field}>
													<TextField size='small' required fullWidth name={col.field} label={col.placeholder} value={activeRow[col.field]} onChange={handleChange} disabled={col.disabled} />
												</Grid>
											)
										}
									}
								})}
							</Grid>
						</FormControl>
						<FormHelperTexts>{registerError}</FormHelperTexts>
					</Boxs>

					<Button variant='contained' color='primary' size='small' onClick={onSubmit} sx={{ mt: 10, width: 100 }}>
						저장
					</Button>
				</Box>
			</Container>
		)
	}

	useEffect(() => {
		onLoad()
	}, [pageInfo])

	useEffect(() => {
		const size = window.getComputedStyle(inputRef.current, null).getPropertyValue("font-size")

		set_fontSize(size)
	}, [])

	const dg_title = "수강신청 정보"
	const memo_DgContent = useMemo(() => {
		return <DgContent />
	}, [record, detailScreen])
	if (dataList != null) {
		return (
			<div ref={inputRef}>
				<MyDialog
					title={dg_title}
					component={memo_DgContent}
					dialogHandler={dgHandler}
					callback={() => {
						set_detailScreen(false)
						set_isNew(false)
					}}
				/>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
					}}>
					<div style={{ paddingRight: 10 }}>
						<h1>수강신청 관리 </h1>
					</div>
					<div>
						<Button
							variant='contained'
							color='secondary'
							size='small'
							onClick={() => {
								onCreate()
							}}>
							생성(테스트용도, 실제는 보호자가 폰에서 수강신청해야 함)
						</Button>
					</div>
				</div>

				<div style={{ paddingTop: 20 }}>
					<MUITable>
						<MyTableHead>
							<TableRow>
								{fields.map((col, index) => {
									if (col.visible) {
										return (
											<TableCell key={index} size='small' key={col.field}>
												{col.placeholder}
												{col.canSrch ? (
													<Fragment>
														<br />
														<TextField
															label=''
															variant='outlined'
															size='small'
															inputProps={{
																style: {
																	fontSize: "0.875em",
																	padding: 5,
																	backgroundColor: "#fff",
																},
															}}
															value={terms[col.field]}
															onChange={(e) => {
																const newTerms = { ...terms }
																newTerms[col.field] = e.target.value
																set_terms(newTerms)
															}}
														/>
													</Fragment>
												) : (
													<Fragment>
														<br />
														<br />
													</Fragment>
												)}
											</TableCell>
										)
									}
								})}
								<TableCell size='small'></TableCell>
							</TableRow>
						</MyTableHead>
						<TableBody>
							{Object.keys(schoolGroup).map((sid) => {
								return (
									<Fragment>
										<TableRow>
											<TableCell rowSpan={schoolRowSpan[sid]}>{schoolGroup[sid].length > 0 ? schoolGroup[sid][0].schoolName : "데이터 없음"}</TableCell>
										</TableRow>
										{Object.keys(dataList).map((lid) => {
											if (dataList[lid][0].schoolId === +sid) {
												return (
													<Fragment key={lid}>
														<TableRow>
															<TableCell rowSpan={dataList[lid].length + 1}>
																{dataList[lid].length > 0 ? dataList[lid][0].lectureName : "데이터 없음"}
																<FlatButton variant='outlined' size='small' style={{ marginLeft: 10 }} onClick={() => loadSelStudentList(lid)}>
																	선발/마감
																</FlatButton>
																<FlatButton variant='outlined' size='small' style={{ marginLeft: 10 }} onClick={() => genAttdnc(lid)}>
																	출석부생성
																</FlatButton>
															</TableCell>
														</TableRow>
														{dataList[lid].map((row, index) => {
															return (
																<TableRow
																	onClick={() => {
																		set_selIdx(index)
																		set_record(row)
																	}}>
																	{fields.map((col, index2) => {
																		if (col.visible && col.field !== "lectureName" && col.field !== "schoolName") {
																			return (
																				<TableCell key={index2} size='small'>
																					{row[col.field]}
																				</TableCell>
																			)
																		}
																	})}
																	<TableCell size='small'>
																		<FlatButton variant='outlined' size='small' style={{ marginRight: 5 }} onClick={() => onDetail(row.id)}>
																			보기
																		</FlatButton>
																		<FlatButton variant='outlined' color='error' size='small' onClick={() => onDelete(row.id)}>
																			삭제
																		</FlatButton>
																	</TableCell>
																</TableRow>
															)
														})}
													</Fragment>
												)
											}
										})}
									</Fragment>
								)
							})}
						</TableBody>
						<TableFooter>
							<TableRow>
								<TablePagination
									rowsPerPageOptions={[{ label: "All", value: -1 }, 10, 20]}
									colSpan={visibleColumns.length + 1}
									count={totalCount}
									rowsPerPage={pageInfo.pageSize}
									page={pageInfo.pageNum}
									SelectProps={{
										inputProps: {
											"aria-label": "rows per page",
										},
										native: true,
									}}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
									ActionsComponent={TablePaginationActions}
									labelDisplayedRows={({ from, to, count }) => {
										// return '' + from + '-' + to + ' 개 ' + count
										return `${from} - ${to} of ${count}`
									}}
									labelRowsPerPage={"페이지당 갯수"}
								/>
							</TableRow>
						</TableFooter>
					</MUITable>

					{renderSnackbar()}
					{renderIndicator()}
					<dg_content />
				</div>
			</div>
		)
	}
}

export default TeacherRegiPart
